import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMobileReservationReducer from '../mobilereservation/mobilereservation.reducer';
import * as fromMobileReservationState from '../mobilereservation/mobilereservation.state';
import { MobileReservationState } from './mobilereservation.state';
import * as fromRoomSelectors from '../rooms/rooms.selector';

export const selectMobileReservationState = createFeatureSelector<MobileReservationState>(
  fromMobileReservationState.inRoomMobileReservationFeatureKey
);

export const selectMobileReservationEntities = createSelector(
  selectMobileReservationState,
  fromMobileReservationReducer.selectMobileReservationEntities
);

export const selectAllMobileReservations = createSelector(
  selectMobileReservationState,
  fromMobileReservationReducer.selectAllMobileReservations
);

// Gets the (first) MobileReservation of the matching that contains any subreservation with a matching room number
export const selectCurrentMobileReservation = createSelector(
  selectAllMobileReservations,
  fromRoomSelectors.selectCurrentRoom,
  (reservations, room) =>
    reservations
      .filter((reservation) => !!room?.HotelCode && reservation?.HotelCode === room.HotelCode)
      .filter(
        (reservation) =>
          !!room?.Room && (reservation.SubReservations?.filter((sub) => sub.UnitCode === room.Room).length ?? 0) > 0 // Check that it's not empty otherwise js evals `[]` as truthy
      )?.[0]
);

export const selectHasCurrentMobileReservation = createSelector(
  selectCurrentMobileReservation,
  (reservation) => !!reservation
);
